import { render, staticRenderFns } from "./listsAdd.vue?vue&type=template&id=7f89203d&"
import script from "./listsAdd.vue?vue&type=script&lang=js&"
export * from "./listsAdd.vue?vue&type=script&lang=js&"
import style0 from "./listsAdd.vue?vue&type=style&index=0&id=7f89203d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports